import { getConsentActionDescriptor } from './documentConsent';
import { resolvePublishedDocumentEditTarget } from './publishedDocumentEditor';

const clean = (value) => String(value || '').trim();
const upper = (value) => clean(value).toUpperCase();
const toVersion = (value) => Math.max(0, Number(value || 0) || 0);

export const TRACKED_PUBLICATION_EVENT_TYPES = ['DOCUMENT_PUBLISHED', 'DOCUMENT_CONSENT_REQUESTED'];

export const isTrackedPublicationEventType = (value) => TRACKED_PUBLICATION_EVENT_TYPES.includes(upper(value));

export const buildPublicationIdentity = (row = {}, meta = {}) => {
  const typeUpper = upper(row?.typeUpper || row?.type || meta?.type);
  const documentId = clean(row?.documentId || row?.id || meta?.documentId || meta?.id);
  const publicationSeriesId = clean(
    row?.publicationSeriesId ||
      row?.event?.payload?.publicationSeriesId ||
      row?.payload?.publicationSeriesId ||
      meta?.publicationSeriesId ||
      documentId
  );
  const publicationVersion = toVersion(
    row?.publicationVersion ||
      row?.event?.payload?.publicationVersion ||
      row?.payload?.publicationVersion ||
      meta?.publicationVersion ||
      meta?.publication?.version ||
      0
  );
  const isTrackedPublication = Boolean(publicationSeriesId && publicationVersion > 0 && (isTrackedPublicationEventType(typeUpper) || upper(meta?.type) === 'CONTRACT' || upper(meta?.type) === 'PROCURATION' || Boolean(meta?.publicationSeriesId)));

  return {
    documentId,
    publicationSeriesId,
    publicationVersion,
    typeUpper,
    isTrackedPublication,
  };
};

export const buildLatestPublicationVersionBySeries = (...sources) => {
  const out = {};

  sources.flat().forEach((item) => {
    if (!item) return;
    const identity = buildPublicationIdentity(item, item);
    if (!identity.isTrackedPublication) return;
    out[identity.publicationSeriesId] = Math.max(out[identity.publicationSeriesId] || 0, identity.publicationVersion);
  });

  return out;
};

export const buildPublicationVersionState = ({ row = {}, meta = {}, latestPublicationVersionBySeries = {} } = {}) => {
  const identity = buildPublicationIdentity(row, meta);
  const latestVersion = identity.publicationSeriesId
    ? Math.max(toVersion(latestPublicationVersionBySeries?.[identity.publicationSeriesId] || 0), identity.publicationVersion)
    : 0;
  const isCurrentVersion = Boolean(identity.isTrackedPublication && identity.publicationVersion >= latestVersion);
  const isHistoricalVersion = Boolean(identity.isTrackedPublication && latestVersion > identity.publicationVersion);
  const versionBadge = identity.isTrackedPublication
    ? (isCurrentVersion ? `v${identity.publicationVersion || 1} Atual` : `v${identity.publicationVersion || 1} Histórico`)
    : '';

  return {
    ...identity,
    latestPublicationVersion: latestVersion,
    isCurrentVersion,
    isHistoricalVersion,
    versionBadge,
  };
};

export const buildPublishedDocumentActionState = ({ row = {}, meta = {}, resolvedUrl = '', consentSaving = false } = {}) => {
  const documentId = clean(row?.documentId || meta?.documentId || row?.id);
  const fileUrl = clean(row?.fileUrl || meta?.fileUrl || resolvedUrl);
  const consentTarget = {
    id: documentId,
    documentId,
    requiresConsent: Boolean(meta?.requiresConsent),
    consentStatus: clean(meta?.consentStatus),
    status: clean(meta?.status),
  };

  return {
    canOpenDocument: Boolean(documentId || fileUrl),
    canEditDocument: Boolean(resolvePublishedDocumentEditTarget(row) && documentId),
    consentAction: getConsentActionDescriptor(consentTarget),
    consentSaving: Boolean(consentSaving),
  };
};
